module.exports = __webpack_public_path__ + "img/base.01863bd2.png";